import type { MantineColor, StyleProp } from '@mantine/core'
import type { OrderDetails } from '@/entities/order/model'
import { Group, Text } from '@mantine/core'
import styles from './OrderItemWithMetaInfoCompact.module.css'

interface OrderItemWithMetaInfoCompactProps {
  orderId: OrderDetails['orderId']
  bg?: StyleProp<MantineColor>
  customerName?: string
  emojiItems?: string[]
  onClick?: (e: React.MouseEvent, ...args: any) => void
}

export function OrderItemWithMetaInfoCompact({
  orderId,
  bg,
  customerName,
  emojiItems,
  onClick,
}: OrderItemWithMetaInfoCompactProps) {
  return (
    <Group
      className={styles.orderItemWithMetaInfoCompact}
      bg={bg}
      justify="space-between"
      gap={6}
      p={6}
      onClick={(e: React.MouseEvent) => onClick?.(e, orderId)}
      data-testid="order-item-with-meta-info-compact"
      wrap="nowrap"
      style={{ overflow: 'hidden' }}
    >
      <Text
        className={styles.wordBreak}
        flex={1}
        c="gray.8"
        fw={700}
        size="xs"
        lh="normal"
        component="span"
        style={{ flexGrow: 1, flexShrink: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {customerName}
      </Text>

      {emojiItems?.length && (
        <Group gap={2} style={{ flexShrink: 0 }}>
          <Text fw={500} size="xs" lh="normal" component="span">
            {emojiItems.join('')}
          </Text>
        </Group>
      )}
    </Group>
  )
}
